.container {
  flex: 0 1 4rem;
  display: flex;
  flex-direction: column;
  padding: 0 0.5rem;

  --track-width: var(--h5w-slicingSlider-track--width, 2px);
  --track-color: var(--h5w-slicingSlider-track--color, slategray);
  --thumb-size: 1.375em;
  --thumb-bgColor: var(--h5w-slicingSlider-thumb--bgColor, whitesmoke);
}

.label {
  margin-bottom: 0.25rem;
  text-align: center;
  font-size: 0.875em;
}

.sublabel {
  composes: label;
  font-size: 0.75em;
  color: var(--h5w-slicingSlider-bounds--color, #333);
}

.slider {
  flex: 1 1 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 5rem;
  cursor: pointer;
}

.track {
  flex: 1;
  margin: calc(var(--thumb-size) / 2) 0;
  border-left: var(--track-width) solid var(--track-color);
  border-radius: var(--track-width);
}

.thumb {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.125rem 0.25rem;
  background-color: var(--thumb-bgColor);
  border: 2px solid
    var(--h5w-slicingSlider-thumb--borderColor, var(--track-color));
  border-radius: calc(var(--thumb-size) / 2);
  height: var(--thumb-size);
  min-width: var(--thumb-size);
  cursor: grab;
}

.thumbValue {
  font-size: 0.625em;
}

.mark {
  width: 0.5rem;
  height: 0.5rem;
  background-color: var(
    --h5w-slicingSlider-mark--bgColor,
    var(--thumb-bgColor)
  );
  border: 2px solid
    var(--h5w-slicingSlider-mark--borderColor, var(--track-color));
  border-radius: 50%;
  transform: translateY(-100%);
}
